import React from 'react';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';

export default function SendNfse({ data }) {
  const { userName, createdAt } = data;

  return(
    <Grid container>
      <Grid xs={12}>
        <Typography color='primary'>
          <b>{userName}</b> desabilitou o envio automático de nota fiscal em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
        </Typography>
      </Grid>
    </Grid>
  );
}